import { ApiResponse } from "../../../types/ApiResponse";
import { DataArray } from "../../../types/DataArray";
import api from "../../../utils/API";
import {
  TransactionDTO,
  TransactionOmniDTO,
  TransactionPublicDTO,
  TransactionVerifyOtpDTO,
} from "../dto";
import { Transactions } from "../entity";

export const getTransaction = (filter?: {
  startDate?: string;
  endDate?: string;
}): ApiResponse<DataArray<Transactions>> =>
  api.get("/v1/transactions", { params: filter });

export const postTransaction = (params: TransactionDTO) =>
  api.post("/v1/transactions", params);
export const deleteTransaction = (
  id: string
): ApiResponse<{ message: boolean }> => api.delete(`/v1/transactions/${id}`);
export const getTransactionById = (
  id: string
): ApiResponse<{
  transaction: Transactions;
  details: any;
  transactionLogs: any[];
}> => api.get(`/v1/transactions/${id}`);

export const postTransactionOmni = (params: TransactionOmniDTO) =>
  api.post("/v1/transactions/omni/inq", params);

export const patchTransactionCancel = (id: string) =>
  api.patch(`/v1/transactions/cancel/${id}`);

export const patchTransactionRetry = (id: string) =>
  api.patch(`/v1/transactions/retry/${id}`);

export const postTransactionVerifyOtp = (params: TransactionVerifyOtpDTO) =>
  api.post("/v1/transactions/verify-otp", params);

export const postTransactionPublic = (params: TransactionPublicDTO) =>
  api.post("/v1/public/transactions", params);

export const confirmTransaction = (id: string): ApiResponse<Transactions> =>
  api.patch(`/v1/transactions/hifi/confirm/${id}`);

export const getTransactionHifiair = (filter?: {
  startDate?: string;
  endDate?: string;
}): ApiResponse<DataArray<Transactions>> =>
  api.get("/v1/transactions/hifi", { params: filter });

export const downloadTransactionExcel = (
  startDate: string,
  endDate: string
): Promise<Blob> =>
  api
    .get(`/v1/transactions/download`, {
      params: { startDate, endDate },
      responseType: "blob",
    })
    .then((res) => res.data);

export const downloadTransactionHifiExcel = (
  startDate: string,
  endDate: string
): Promise<Blob> =>
  api
    .get(`/v1/transactions/hifi/download`, {
      params: { startDate, endDate },
      responseType: "blob",
    })
    .then((res) => res.data);
